import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-redirect-manager',
  templateUrl: './redirect-manager.component.html',
  styleUrls: ['./redirect-manager.component.scss']
})
export class RedirectManagerComponent implements OnInit, AfterViewInit {
    ngAfterViewInit(): void {
      var page = {} as any;
      var c = this.route.paramMap.subscribe(x => {
        page = x as any
        console.log(page.params.page, page.params.branch);

      })
      if (page.params.page == 1) {
        this.router.navigate(["./dashboard/outlet-manager/user-management"]);
      }
      else if (page.params.page == 2) {
        this.router.navigate(["./dashboard/outlet-manager/branch-management"]);
      }
    }

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    
  }

}
